import { ProtectedRoute } from "@/lib/auth/protected-route"
import { Roles } from "@/lib/team/roles"
import { ConsumerIntakeEstimateWizard } from "@/components/estimates/consumer-intake-estimate/wizard"

// Consumer Intake Estimate — parallel route at /estimates/consumer-intake.
// The wizard renders its own takeover layout (logo-less; the existing
// AppLayout doesn't wrap this page so the wizard owns the full viewport).
//
// TEMP-FOR-DEV: EstimatePrerequisiteGate is intentionally OMITTED
// while this flow is in active development so designers / PMs can
// iterate without first setting up a body shop or shop rates.
// Submission still requires a real teamId (the wizard guards that),
// but the create-flow loads regardless of fees / connected-shop
// state. Re-enable the gate here before merging to production:
//
//   import { EstimatePrerequisiteGate } from "@/components/estimates/estimate-prerequisite-gate"
//   <EstimatePrerequisiteGate>
//     <ConsumerIntakeEstimateWizard />
//   </EstimatePrerequisiteGate>
export default function ConsumerIntakeEstimatePage() {
  return (
    <ProtectedRoute
      allowedRoles={[
        Roles.ServiceAdvisor,
        Roles.Estimator,
        Roles.Director,
        Roles.GeneralManager,
        Roles.ServiceManager,
      ]}
    >
      <ConsumerIntakeEstimateWizard />
    </ProtectedRoute>
  )
}
